export const initRemoveTags = () => {
  const tagsModule = document.querySelector('.single .et_pb_code.post-tags');
  const tags = document.querySelector(
    '.single .et_pb_code.post-tags .et_pb_code_inner .post-tags',
  );

  if (tagsModule && tags) {
    const computed = window.getComputedStyle(tags);

    if (computed.display === 'none') {
      tagsModule.style.display = 'none';
    }
  }
};
